import * as React from 'react'
import { Link as RouterLink } from "react-router-dom"
import { Link } from "@mui/material"

import { LabelCountry } from "@components"
import { MARKETPLACES_ROUTES } from "@constants"
import { commonFiltersShareValue, country, encodeCommonFiltersShareValue, retailer } from "@signals"

export default function retailerColumn() {
    return {
        name: 'retailer', label: 'Retailer',
        options: {
            headerAlign: 'left',
            customBodyRowRenderLite: (value, dataRow) => {
                const specificFilters = {
                    country: dataRow?.country ? [dataRow.country] : country.peek(),
                    retailer: dataRow?.retailerID ? [dataRow.retailerID] : []
                }
                const url = `${MARKETPLACES_ROUTES.SELLER_DETAILS_PATH}?sp=${encodeCommonFiltersShareValue({...commonFiltersShareValue.peek(), ...specificFilters})}`
                
                const handleClick = () => {
					country.value = [dataRow.country]
					retailer.value = [dataRow.retailerID]
				}
				
				return <Link
                        component={RouterLink}
                        to={url}
                        onClick={handleClick}
                    >
                        <LabelCountry label={value} country={dataRow.country} />
                    </Link>
            }
        }
    }
}